import { render, staticRenderFns } from "./pressKit.vue?vue&type=template&id=759d1dda&scoped=true&"
import script from "./pressKit.vue?vue&type=script&lang=js&"
export * from "./pressKit.vue?vue&type=script&lang=js&"
import style0 from "./pressKit.vue?vue&type=style&index=0&id=759d1dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759d1dda",
  null
  
)

export default component.exports